
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export type ImageVariable = {
  id: string;
  variable_name: string;
  description: string;
  alt_tag: string;
  meta_description: string;
  keywords: string[];
  use_case: string;
  schema_snippet: string;
  image_url: string | null;
  title: string;
  width: number | null;
  height: number | null;
  file_size: number | null;
  mime_type: string | null;
  created_at: string;
  updated_at: string;
};

export const useImageVariables = () => {
  return useQuery({
    queryKey: ['imageVariables'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('image_variables')
        .select('*')
        .order('variable_name');

      if (error) throw new Error(error.message);
      return data as ImageVariable[];
    },
  });
};

export const useImageVariable = (id: string) => {
  return useQuery({
    queryKey: ['imageVariable', id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('image_variables')
        .select('*')
        .eq('id', id)
        .single();

      if (error) throw new Error(error.message);
      return data as ImageVariable;
    },
    enabled: !!id,
  });
};
